import React, { useContext, useMemo } from "react";
import { useTextDomainContext } from "@/app/providers";
import { SelectDropdown } from "@/components";
import { useEnergyType } from "@/hooks";
import type { SxProps, Theme } from "@mui/material";

interface EnergyTypeDropdownProps {
  componentLabel?: string;
  defaultValue?: string;
  currentTeam?: string;
  currentSubsidiary?: string;
  country?: string;
  showAll?: boolean;
  allPosition?: "start" | "end";
  onChange?: (value: any) => void;
  required?: boolean;
  sx?: SxProps<Theme>;
}

export const EnergyTypeDropdown = (props: EnergyTypeDropdownProps) => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  // const energyType = useEnergyTypeArray();
  const { energyType } = useEnergyType(
    props?.currentTeam,
    props?.currentSubsidiary,
    props?.country,
  );

  //#region useMemo
  const componentLabel = useMemo(() => {
    return props.componentLabel || gettext("Energy Type");
  }, [gettext, props.componentLabel]);

  const options = useMemo(() => {
    return energyType;
  }, [energyType]);

  const defaultValue = useMemo(() => {
    return props.defaultValue;
  }, [options, props.defaultValue]);
  //#endregion useMemo

  return (
    <SelectDropdown
      options={options}
      componentLabel={componentLabel}
      defaultValue={defaultValue}
      required={props.required}
      showAll={props.showAll}
      allPosition={props.allPosition}
      onChange={props.onChange}
      visualStyle="autoComplete"
      sx={props.sx}
    />
  );
};
